/**
 * @generated SignedSource<<00b2c2fca7ca56864ede3d2aaec65c31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteJsonParams_seoRoute$data = {
  readonly jsonParams: ReadonlyArray<{
    readonly name: string | null;
    readonly value: string | null;
  }>;
  readonly " $fragmentType": "SeoRouteJsonParams_seoRoute";
};
export type SeoRouteJsonParams_seoRoute$key = {
  readonly " $data"?: SeoRouteJsonParams_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRouteJsonParams_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRouteJsonParams_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SeoRouteJsonParam",
      "kind": "LinkedField",
      "name": "jsonParams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "5f300ff997c704c212e66fd8746b7d7d";

export default node;
